import { render } from "./EventDetailsPage.vue?vue&type=template&id=7790e898&ts=true"
import script from "./EventDetailsPage.vue?vue&type=script&lang=ts"
export * from "./EventDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__